//主页面
// const index = r => require.ensure([], () => r(require('@/components/home.vue')), 'index');
const index = () => import(/* webpackChunkName:'grounp' */ '@/components/home.vue');

//历史银行交易流水详情
const bankDirectFlowList = () =>
  import(/* webpackChunkName:'grounp' */ '@/pages/financeCenter/bankDirectFlow/list.vue');

//当日银行交易流水详情
const bankFlowDayList = () =>
  import(
    /* webpackChunkName:'grounp' */ '@/pages/financeCenter/bankDirectFlow/bankFlowDayList.vue'
  );

const bankDirectFlow = {
  path: '/bankDirectFlow',
  component: index,
  children: [
    {
      path: 'bankDirectFlowList',
      name: 'bankDirectFlowList',
      component: bankDirectFlowList,
      meta: {
        keepAlive: true,
        title: '银行交易流水',
      },
    },
    {
      path: 'bankFlowDayList',
      name: 'bankFlowDayList',
      component: bankFlowDayList,
      meta: {
        keepAlive: true,
        title: '当日银行交易流水',
      },
    },
  ],
};
export default bankDirectFlow;
